import { render, staticRenderFns } from "./vipPanel.vue?vue&type=template&id=38bace12&"
import script from "./vipPanel.vue?vue&type=script&lang=js&"
export * from "./vipPanel.vue?vue&type=script&lang=js&"
import style0 from "./vipPanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports